import addressDefinitionsByCountry from '../components/address/address-definitions-by-country';

export const lookupAddressFieldDefinitionByCountryAndFieldName = (country, fieldName) => {
  /*
   * The 'country' parameter (which often comes from 'pudo.currentLocation.country') is typically set to
   * 'window.siteObj.userLocation' in the initial state.
   * This value is used to restrict Google Maps search predictions to the selected country,
   * which explains its usage here.
  */
  const addressFieldDefinitionsForCountry = addressDefinitionsByCountry.get(country);
  return addressFieldDefinitionsForCountry.find(field => field.name === fieldName);
};

export default lookupAddressFieldDefinitionByCountryAndFieldName;
